import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const LinkNext = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="LinkNext" {...props}>
    <path d="M13.293 20.7069C13.6835 21.0974 14.3165 21.0974 14.707 20.7069L23.4141 11.9999L14.707 3.29286C14.3165 2.90238 13.6835 2.90238 13.293 3.29286C12.9025 3.68337 12.9025 4.3164 13.293 4.70692L19.5859 10.9999H2C1.44779 10.9999 1.00011 11.4477 1 11.9999C1.00001 12.5522 1.44772 12.9999 2 12.9999H19.5859L13.293 19.2929C12.9025 19.6834 12.9025 20.3164 13.293 20.7069Z" fill="#000" />
  </StyledIcon>
));

LinkNext.displayName = 'LinkNext';

export { LinkNext };
